import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
import { loadUserSettings } from "../state/userSlice";
import { updateUserFieldSettings, updateOneHeaderSetting } from "../state/userSettingsSlice";
import { GetUserSettings } from "./DocumentListActions";
export function GetSettingsForUser(userId, dispatch) {
  axios.get(`${Globals.baseUrl}/UserSettings/GetSettingsForUser/${userId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      let settings = buildUserSettings(res.data);
      dispatch(loadUserSettings(settings));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetCurrentUser(userId) {
  axios.get(`${Globals.baseUrl}/UserSettings/GetCurrentUser`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetCurrentUser,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function SaveUserSettings(firstName, lastName, fontSize, quickSearchPriority, sendEmailNotifications, defaultHome, email, defaultApp, keepQuickSearch, betaActiveDocuments, dispatch) {
  axios.post(
    `${Globals.baseUrl}/UserSettings/UpdateUserSettings`,
    {
      FirstName: firstName,
      LastName: lastName,
      FontSize: fontSize,
      QuickSearchPriority: quickSearchPriority,
      SendEmailNotifications: sendEmailNotifications,
      ImageViewHeight: null,
      DefaultHome: defaultHome,
      DefaultApp: defaultApp,
      KeepQuickSearch: keepQuickSearch,
      BetaActiveDocuments: betaActiveDocuments
      //email: email,
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      let settings = buildUserSettings(res.data);
      console.log(settings);
      dispatch(loadUserSettings(settings));
      PostAlert("success", "User data updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateUserHeaderSettings(formTypeId, settings, dispatch) {
  console.log(settings);
  axios.post(
    `${Globals.baseUrl}/ActiveDocument/UpdateUserHeaderSettings`,
    {
      formTypeId,
      settings
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      dispatch(updateOneHeaderSetting({
        fieldSetId: formTypeId,
        columns: res.data
      }));
      PostAlert("success", "User settings updated");
    }
  }).catch((res) => {
    console.log(res);
    if (res.response.status === 401) {
      console.log("unauthorized");
      Logout();
    }
  });
}
export function GetUserHeaderSettings(formtypeId, dispatch) {
  console.log("GetUserFieldSettings");
  axios.get(`${Globals.baseUrl}/DocumentList/GetUserHeaderSettings/${fromtypeId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      dispatch(updateUserFieldSettings(res.data));
      console.log("GetuserSettings");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUserFieldSettings(dispatch) {
  console.log("GetUserFieldSettings");
  axios.get(`${Globals.baseUrl}/DocumentList/GetAllUserFieldSettings`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      dispatch(updateUserFieldSettings(res.data));
      console.log("GetuserSettings");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUserFieldSettings2(ftid, dispatch) {
  console.log("GetUserFieldSettings");
  axios.get(`${Globals.baseUrl}/DocumentList/GetUserFieldSettings2/${ftid}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      let result = {
        formTypeId: ftid,
        columns: res.data
      };
      dispatch(updateUserFieldSettings(result));
      console.log("GetuserSettings");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
const buildUserSettings = (settingData) => {
  let userSettings = {};
  if (settingData) {
    settingData.forEach((f) => {
      if (f.name === "pin_user_notes") userSettings.pinUserNotes = f.value;
      if (f.name === "quick_search_priority") userSettings.quickSearchPriority = f.value;
      if (f.name === "font_size_mode") userSettings.fontSizeMode = f.value;
      if (f.name === "doc_image_height") userSettings.docImageHeight = f.value;
      if (f.name === "default_home") userSettings.defaultHome = f.value;
      if (f.name === "document_zoom") userSettings.documentZoom = f.value;
      if (f.name === "default_app") userSettings.defaultApp = f.value;
      if (f.name === "keep_quick_search") userSettings.keepQuickSearch = f.value;
      if (f.name === "send_email_notifications") userSettings.sendEmailNotifications = f.value;
      if (f.name === "enable_beta_active_documents") userSettings.betaActiveDocuments = f.value;
    });
    return userSettings;
  }
};
